import { computed } from 'vue-demi';
import { Area } from '@ilteducation/content-ref-data-types';
import useContentRefData from './use-content-ref-data';

const useAreas = () => {
  const refDataStore = useContentRefData();

  const areas = computed(
    () =>
      refDataStore
        .all('areas')
        .filter((area) => (area as Area).active)
        .sort((a, b) => ((a as Area).order > (b as Area).order ? 1 : -1)) as Area[],
  );

  const isLoading = computed(() => refDataStore.isLoading('areas'));

  const byId = computed(() => (id: string) => refDataStore.byId('areas', id) as Area | undefined);

  const load = () => refDataStore.references('areas');

  // TODO move loading to be done automatically from here?

  return {
    areas,
    byId,
    isLoading,
    load,
  };
};

export default useAreas;
